<template>
  <div class="d-flex flex-wrap align-center" style="gap: 6px">
    <v-chip small color="deep-orange" text-color="white">รถใหญ่ · {{ groupText }}</v-chip>
    <span v-if="!live" class="caption">ยกเลิกแล้ว</span>
    <!-- No week here: the delivery team gives the date when a route is fixed,
         and a week the owner could change read as the customer's choice. -->
    <span v-else class="caption">{{ order.upTripId ? 'จัดรอบแล้ว ' + order.date : 'รอจัดรอบ' }}</span>
    <!-- Labelled, or "รอจัดรอบ ยังไม่ทราบ" reads as one phrase; and at the
         table's 14px, not an input's 16px. -->
    <template v-if="live && isStaff">
      <span class="caption ml-2">การติดตั้ง:</span>
      <v-select class="install-mode" :value="order.installMode" :items="modeItems" dense hide-details
        style="max-width: 120px" @change="changeMode" />
    </template>
    <v-btn v-if="isStaff" small text :to="{ name: 'upcountry' }">หน้ารถใหญ่</v-btn>
    <v-btn v-if="live && canManage" small text color="error" @click="cancel">ยกเลิก</v-btn>
    <v-btn v-else-if="live && canPropose" small text @click="proposeCancel">ขอยกเลิก</v-btn>
  </div>
</template>

<script>
import U from '@/components/upcountry'
import US from '@/components/upcountryService'
import PS from '@/components/proposalService'
import R from '@/components/bookingRules'
import { pushBookDateToSap, bookDateFailedNote } from '@/components/sapBookDate'
import { reportError } from '@/components/report'

export default {
  name: 'upcountryOrderActions',
  props: { order: { type: Object, required: true } },
  data () {
    return {
      modeItems: [{ text: 'ยังไม่ทราบ', value: 'unknown' }, { text: 'ติดตั้ง', value: 'install' }, { text: 'ส่งอย่างเดียว', value: 'drop' }] }
  },
  computed: {
    role () { return this.$store.state.status },
    user () { return this.$store.state.user },
    identities () { return this.$store.getters.identities },
    live () { return R.isActive(this.order.status) },
    isStaff () { return R.isStaffRole(this.role) },
    canManage () { return U.canManageOrder(this.order, this.role, this.identities) },
    canPropose () { return !this.canManage && this.order.proposalStatus !== 'pending' },
    groupText () { return (this.order.upGroup || []).map(U.groupLabel).join(' / ') }
  },
  methods: {
    async run (fn, done) {
      try { await fn(); if (done) await done(); this.$emit('changed') } catch (e) {
        reportError('upcountry order action', e)
        const why = U.actionMessage(e)
        this.$root.$message('ทำรายการไม่สำเร็จ', [why], { type: 'alert', color: 'error', width: 420 })
      }
    },
    changeMode (mode) {
      return this.run(() => US.setInstallMode(this.order.id, { mode, user: this.user, role: this.role }))
    },
    async cancel () {
      const ok = await this.$root.$message('ยกเลิกออเดอร์รถใหญ่', [U.orderRef(this.order)], { type: 'confirm', color: 'warning', width: 420 })
      if (!ok) return
      return this.run(() => US.cancelUpOrder(this.order.id, { user: this.user, reason: 'ยกเลิกโดยผู้จอง', role: this.role, identities: this.identities }),
        async () => {
          const failed = await pushBookDateToSap(this.$store.getters.webPath, Object.assign({}, this.order, { status: 'cancelled' }))
          const note = bookDateFailedNote(failed, { cleared: true })
          if (note) await this.$root.$message('SAP', [note], { type: 'alert', color: 'warning', width: 420 })
        })
    },
    proposeCancel () {
      return this.run(() => PS.proposeCancel(this.order.id, { reason: 'ลูกค้าขอยกเลิก', user: this.user, role: this.role, identities: this.identities }))
    }
  }
}
</script>

<style scoped>
/* The row's text beside it is Vuetify's caption (0.75rem). An input's own 16px
   and its top/bottom padding made the choice sit big and below that line. */
.install-mode {
  margin-top: 0;
  padding-top: 0;
  flex: 0 0 auto;
}
.install-mode ::v-deep .v-select__selection,
.install-mode ::v-deep .v-select__selections input {
  font-size: 0.75rem;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
}
.install-mode ::v-deep .v-select__selection--comma {
  margin: 0;
}
.install-mode ::v-deep .v-select__selections input {
  padding: 0;
}
.install-mode ::v-deep .v-input__slot {
  min-height: 0;
}
.install-mode ::v-deep .v-input__append-inner {
  margin-top: 0;
}
</style>
